import { render, staticRenderFns } from "./Principal.vue?vue&type=template&id=0bc51d2c&scoped=true"
import script from "./Principal.vue?vue&type=script&lang=ts"
export * from "./Principal.vue?vue&type=script&lang=ts"
import style0 from "./Principal.vue?vue&type=style&index=0&id=0bc51d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc51d2c",
  null
  
)

export default component.exports